var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import DtoConverter from '../../../core/utils/dto-converter';
import FraimsyApi from '../../../core/api/fraimsy-api';
import { CartItem } from '../../../models/cart-item';
import { generateRequestString } from '../../../core/helpers/request-helper';
import { DELETE_CART_ITEM_ERROR, DELETE_CART_ITEM_REQUEST, DELETE_CART_ITEM_SUCCESS, DELETE_COLLECTION_CART_ITEM, FETCH_CART_ITEM_ERROR, FETCH_CART_ITEM_REQUEST, FETCH_CART_ITEM_SUCCESS, FETCH_CART_ITEMS_ERROR, FETCH_CART_ITEMS_REQUEST, FETCH_CART_ITEMS_SUCCESS, FETCH_DRAFT_ITEMS_ERROR, FETCH_DRAFT_ITEMS_REQUEST, FETCH_DRAFT_ITEMS_SUCCESS, FETCH_SHIPPING_FEE_ERROR, FETCH_SHIPPING_FEE_REQUEST, FETCH_SHIPPING_FEE_SUCCESS, REPLACE_CART_ITEM, UPDATE_CART_ITEM_ERROR, UPDATE_CART_ITEM_QUANTITY_ERROR, UPDATE_CART_ITEM_QUANTITY_REQUEST, UPDATE_CART_ITEM_QUANTITY_SUCCESS, UPDATE_CART_ITEM_REQUEST, UPDATE_CART_ITEM_SUCCESS, } from './actionTypes';
export var fetchDraftItems = function (requestArguments) {
    if (requestArguments === void 0) { requestArguments = {}; }
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, response, items, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({ type: FETCH_DRAFT_ITEMS_REQUEST });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    url = "cart-items" + generateRequestString(__assign(__assign({}, requestArguments), { is_draft: '1' }));
                    return [4 /*yield*/, FraimsyApi.get(url)];
                case 2:
                    response = _a.sent();
                    if (response.status !== 200) {
                        throw new Error("fetchDraftItems failed: Invalid status code: " + response.status);
                    }
                    items = DtoConverter.createList(CartItem, response.data.data);
                    dispatch({ type: FETCH_DRAFT_ITEMS_SUCCESS, items: items });
                    return [2 /*return*/, items];
                case 3:
                    err_1 = _a.sent();
                    dispatch({ type: FETCH_DRAFT_ITEMS_ERROR });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchCartItems = function (requestArguments) {
    if (requestArguments === void 0) { requestArguments = {}; }
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, response, items, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({ type: FETCH_CART_ITEMS_REQUEST });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    url = "cart-items" + generateRequestString(__assign(__assign({}, requestArguments), { is_draft: '0' }));
                    return [4 /*yield*/, FraimsyApi.get(url)];
                case 2:
                    response = _a.sent();
                    if (response.status !== 200) {
                        throw new Error("fetchCartItems failed: Invalid status code: " + response.status);
                    }
                    items = DtoConverter.createList(CartItem, response.data.data);
                    dispatch({ type: FETCH_CART_ITEMS_SUCCESS, items: items });
                    return [2 /*return*/, items];
                case 3:
                    err_2 = _a.sent();
                    dispatch({ type: FETCH_CART_ITEMS_ERROR });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchCartItem = function (id) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var response, item, err_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch({ type: FETCH_CART_ITEM_REQUEST });
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, FraimsyApi.get("cart-items/" + id)];
            case 2:
                response = _a.sent();
                if (response.status !== 200) {
                    throw new Error("fetchCartItem failed: Invalid status code: " + response.status);
                }
                item = new CartItem(response.data.data);
                dispatch({ type: FETCH_CART_ITEM_SUCCESS, item: item });
                return [2 /*return*/, item];
            case 3:
                err_3 = _a.sent();
                console.log(err_3);
                dispatch({ type: FETCH_CART_ITEM_ERROR });
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
export var updateCartItem = function (id, payload) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var response, item, err_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch({ type: UPDATE_CART_ITEM_REQUEST });
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, FraimsyApi.put("cart-items/" + id, payload)];
            case 2:
                response = _a.sent();
                if (response.status !== 200) {
                    throw new Error("updateCartItem failed: Invalid status code: " + response.status);
                }
                item = new CartItem(response.data.data);
                dispatch({ type: UPDATE_CART_ITEM_SUCCESS, item: item });
                return [2 /*return*/, item];
            case 3:
                err_4 = _a.sent();
                console.log(err_4);
                dispatch({ type: UPDATE_CART_ITEM_ERROR });
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
export var updateCartItemQuantity = function (id, payload) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var response, item, err_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch({ type: UPDATE_CART_ITEM_QUANTITY_REQUEST });
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, FraimsyApi.put("cart-items/" + id + "/quantity", payload)];
            case 2:
                response = _a.sent();
                if (response.status !== 200) {
                    throw new Error("updateCartItemQuantity failed: Invalid status code: " + response.status);
                }
                item = new CartItem(response.data.data);
                dispatch({ type: UPDATE_CART_ITEM_QUANTITY_SUCCESS, item: item });
                return [2 /*return*/, item];
            case 3:
                err_5 = _a.sent();
                console.log(err_5);
                dispatch({ type: UPDATE_CART_ITEM_QUANTITY_ERROR });
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
export var deleteCartItem = function (id) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var response, err_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch({ type: DELETE_CART_ITEM_REQUEST });
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, FraimsyApi.delete("cart-items/" + id)];
            case 2:
                response = _a.sent();
                if (response.status !== 200) {
                    throw new Error("deleteCartItem failed: Invalid status code: " + response.status);
                }
                dispatch({ type: DELETE_CART_ITEM_SUCCESS, id: id });
                dispatch({ type: DELETE_COLLECTION_CART_ITEM, id: id });
                return [2 /*return*/, true];
            case 3:
                err_6 = _a.sent();
                console.log(err_6);
                dispatch({ type: DELETE_CART_ITEM_ERROR });
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/, false];
        }
    });
}); }; };
export var createCartItem = function (productId, productVariantId) { return function () { return __awaiter(void 0, void 0, void 0, function () {
    var response, err_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, FraimsyApi.post("cart-items", {
                        product_id: productId,
                        product_variant_id: productVariantId,
                    })];
            case 1:
                response = _a.sent();
                if (response.status !== 201) {
                    throw new Error("createCartItem failed: Invalid status code: " + response.status);
                }
                return [2 /*return*/, new CartItem(response.data.data)];
            case 2:
                err_7 = _a.sent();
                console.log(err_7);
                return [2 /*return*/, null];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var updateCartItemAddon = function (cartItemId, productAddonId, quantity) { return function () { return __awaiter(void 0, void 0, void 0, function () {
    var response, err_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, FraimsyApi.post("cart-items/" + cartItemId + "/addons", {
                        product_addon_id: productAddonId,
                        quantity: quantity,
                    })];
            case 1:
                response = _a.sent();
                if (response.status !== 201) {
                    throw new Error("updateCartItemAddon failed: Invalid status code: " + response.status);
                }
                return [2 /*return*/, new CartItem(response.data.data)];
            case 2:
                err_8 = _a.sent();
                console.log(err_8);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, null];
        }
    });
}); }; };
export var deleteCartItemAddon = function (cartItemId, cartItemAddonId) { return function () { return __awaiter(void 0, void 0, void 0, function () {
    var response, err_9;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, FraimsyApi.delete("cart-items/" + cartItemId + "/addons/" + cartItemAddonId)];
            case 1:
                response = _a.sent();
                if (response.status !== 200) {
                    throw new Error("deleteCartItemAddon failed: Invalid status code: " + response.status);
                }
                return [2 /*return*/, new CartItem(response.data.data)];
            case 2:
                err_9 = _a.sent();
                console.log(err_9);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, null];
        }
    });
}); }; };
export var fetchShippingFee = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var response, err_10;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: FETCH_SHIPPING_FEE_REQUEST });
                return [4 /*yield*/, FraimsyApi.post("shipping-fee", { currency_id: window.App.locale.currencyId })];
            case 1:
                response = _a.sent();
                if (response.status !== 200) {
                    throw new Error("fetchShippingFee failed: Invalid status code: " + response.status);
                }
                dispatch({ type: FETCH_SHIPPING_FEE_SUCCESS, data: response.data });
                return [2 /*return*/, response.data.shipping_fee];
            case 2:
                err_10 = _a.sent();
                dispatch({ type: FETCH_SHIPPING_FEE_ERROR });
                console.log(err_10);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, null];
        }
    });
}); }; };
export var replaceCartItem = function (item) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        dispatch({ type: REPLACE_CART_ITEM, item: item });
        return [2 /*return*/];
    });
}); }; };
export var deleteCollectionCartItem = function (item) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        dispatch({ type: DELETE_COLLECTION_CART_ITEM, id: item.id });
        return [2 /*return*/];
    });
}); }; };
